import { render } from "./StatsModelSelector.vue?vue&type=template&id=ea4f2daa&scoped=true"
import script from "./StatsModelSelector.vue?vue&type=script&lang=ts"
export * from "./StatsModelSelector.vue?vue&type=script&lang=ts"

import "./StatsModelSelector.vue?vue&type=style&index=0&id=ea4f2daa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ea4f2daa"

export default script